import React, { useState, useEffect } from "react";
import { Link as ScrollLink } from "react-scroll";
import axios from "axios";

export default function Header() {
  const [logo, setLogo] = useState("/assets/images/logo/logo-green.png");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    axios
      .get("/api/settings/logo")
      .then((res) => {
        if (res.data.logo) setLogo(res.data.logo);
      })
      .catch((err) => console.log("Logo fetch error:", err));
  }, []);

  return (
    <div className="header-header-two">
      {/* Top Bar */}
      <div className="header-two-solari header-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="header-top-m">
                <div className="left">
                  <div className="inf">
                    <i className="fa-regular fa-clock"></i>
                    <p id="business-hours">
                      Mon - Sun : 09:00 AM - 09:00 PM / 12:00 AM - 12:00 AM
                    </p>
                  </div>
                  <div className="inf">
                    <i className="fa-regular fa-envelope"></i>
                    <a href="mailto:info@cauverytours.com" id="contact-email">
                      info@cauverytours.com
                    </a>
                  </div>
                </div>
                <div className="right">
                  <div className="social-header-top-h2">
                    <span>Visit Us:</span>
                    <ul>
                      <li><a href="#"><i className="fa-brands fa-facebook-f"></i></a></li>
                      <li><a href="#"><i className="fa-brands fa-twitter"></i></a></li>
                      <li><a href="#"><i className="fa-brands fa-linkedin-in"></i></a></li>
                      <li><a href="#"><i className="fa-brands fa-instagram"></i></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Nav */}
      <div className="header-main-h2 header--sticky">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12 d-flex justify-content-between align-items-center">
              <a href="/" className="logo-area">
                <img src={logo} alt="logo" />
              </a>

              {/* Desktop Menu */}
              <div className="header-nav main-nav-one d-none d-lg-block">
                <nav>
                  <ul>
                    <li><ScrollLink to="home" smooth duration={500}>Home</ScrollLink></li>
                    <li><ScrollLink to="about" smooth duration={500}>About Us</ScrollLink></li>
                    <li><ScrollLink to="services" smooth duration={500}>Tour Packages</ScrollLink></li>
                    <li><ScrollLink to="gallery" smooth duration={500}>Happiest Customers</ScrollLink></li>
                    <li><ScrollLink to="Contact" smooth duration={500}>Contact Us</ScrollLink></li>
                  </ul>
                </nav>
              </div>

              {/* Mobile Menu Button */}
              <button
                className="mobile-menu-toggle d-lg-none"
                onClick={() => setMobileMenuOpen(true)}
              >
                <i className="fa fa-bars"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu Panel */}
        <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
          <button className="close-menu" onClick={() => setMobileMenuOpen(false)}>
            <i className="fa fa-times"></i>
          </button>
          <nav>
            <ul>
              <li><ScrollLink to="home" smooth duration={500} onClick={() => setMobileMenuOpen(false)}>Home</ScrollLink></li>
              <li><ScrollLink to="about" smooth duration={500} onClick={() => setMobileMenuOpen(false)}>About Us</ScrollLink></li>
              <li><ScrollLink to="services" smooth duration={500} onClick={() => setMobileMenuOpen(false)}>Travel Packages</ScrollLink></li>
              <li><ScrollLink to="gallery" smooth duration={500} onClick={() => setMobileMenuOpen(false)}>Happiest Customers</ScrollLink></li>
              <li><ScrollLink to="Contact" smooth duration={500} onClick={() => setMobileMenuOpen(false)}>Contact Us</ScrollLink></li>
            </ul>
          </nav>
          <div className="mobile-social">
            <ul>
              <li><a href="#"><i className="fa-brands fa-facebook-f"></i></a></li>
              <li><a href="#"><i className="fa-brands fa-twitter"></i></a></li>
              <li><a href="#"><i className="fa-brands fa-youtube"></i></a></li>
              <li><a href="#"><i className="fa-brands fa-linkedin-in"></i></a></li>
            </ul>
          </div>
        </div>

        {/* Overlay */}
        {mobileMenuOpen && (
          <div className="mobile-menu-overlay" onClick={() => setMobileMenuOpen(false)}></div>
        )}
      </div>

      {/* CSS */}
      <style jsx>{`
        .header-main-h2 {
          position: relative;
        }

        /* Overlay */
        .mobile-menu-overlay {
          position: fixed;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background: rgba(0,0,0,0.5);
          z-index: 998;
        }

        /* Mobile Menu */
        .mobile-menu {
          position: fixed;
          top: 0; left: -100%;
          width: 75%; max-width: 300px;
          height: 100%;
          background: #fff;
          z-index: 999;
          padding: 50px 20px 20px;
          transition: left 0.4s ease-in-out;
          display: flex;
          flex-direction: column;
        }
        .mobile-menu.open { left: 0; }

        /* Close Button */
        .mobile-menu .close-menu {
          position: absolute;
          top: 20px; right: 20px;
          font-size: 22px;
          background: none;
          border: none;
          cursor: pointer;
          z-index: 1000;
          color: #333;
        }

        /* Mobile Menu Links */
        .mobile-menu nav ul {
          list-style: none;
          padding: 0;
          margin-top: 60px;
        }
        .mobile-menu nav ul li {
          margin-bottom: 25px;
          font-size: 18px;
        }
        .mobile-menu nav ul li a {
          text-decoration: none;
          color: #333;
          transition: color 0.3s;
          cursor: pointer;
        }
        .mobile-menu nav ul li a:hover {
          color: #00b894;
        }

        /* Social Links */
        .mobile-social {
          margin-top: auto;
        }
        .mobile-social ul {
          display: flex;
          gap: 15px;
          list-style: none;
          padding: 0;
        }
        .mobile-social ul li a {
          color: #333;
          font-size: 18px;
          transition: color 0.3s;
        }
        .mobile-social ul li a:hover {
          color: #00b894;
        }

        /* Mobile Menu Toggle Button */
        .mobile-menu-toggle {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
        }

        .header--sticky {
padding: 30px 0px;
        }

        .mobile-menu-toggle {
          text-align:right;
        }

        /* Mobile Menu Links */
.mobile-menu nav ul {
  list-style: none;
  padding: 0;
  margin-top: 0px;
  display: block; /* make the list vertical */
}

.mobile-menu nav ul li {
  margin-bottom: 0px; /* space between each item */
  font-size: 20px;
}

.mobile-menu nav ul li a {
  text-decoration: none;
  color: #333;
  transition: color 0.3s;
  display: block; /* full width clickable */
}

.mobile-menu nav ul li a:hover {
  color: #00b894;
}

      `}</style>
    </div>
  );
}
